import Model from './Model';

export default class PendingEvaluations extends Model {
    id;
    name;
    first_name;
    last_name;
    diplomas;

    static apiPath() {
        return 'evaluations/pending';
    }

    toJson() {
        // When submitting an change, we need to send id's for the relations instead of the values themselves.
        const dtoIds = {
            id: this.id
        };

        return { ...this, ...dtoIds };
    }
}



// WEBPACK FOOTER //
// ./src/models/PendingEvaluations.js